import React, { Component } from 'react'
import { withFirebase, firebaseConnect, populate } from "react-redux-firebase";
import { compose } from 'redux'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Divider from '@material-ui/core/Divider'
import { connect } from 'react-redux'
import classNames from 'classnames'
import CircularProgress from '@material-ui/core/CircularProgress'
import Button from '@material-ui/core/Button'
import { userActions } from '../actions/user.actions'
import { homeActions } from '../actions/home.actions'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import { getProjectUsers, getProjectId, getProjectName, getProjectSubscription, getDailyUpdateUsers, getProjectAddress, getDailyCommitUsers } from '../selectors/project.selector'
import { getCurrentUserId } from '../selectors/user.selector'
import { getProfile } from '../selectors/profile.selector'
import { getSelectedLookaheadId } from '../selectors/lookahead.selector'
import { withStyles } from '@material-ui/core/styles'
import parsePhoneNumber from 'libphonenumber-js'

const styles = theme => ({
  profileContainer: {
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '626px',
    display: 'flex',
    height: '100%',
    flexDirection: 'column'
  },
  profilePaper: {
    width: '626px',
    paddingRight: '20px',
    paddingLeft: '20px',
    paddingTop: '15px',
    paddingBottom: '15px',
    marginTop: '16px',
    marginBottom: '16px'
  },
  profileDivider: {
    marginTop: '16px',
    marginBottom: '16px'
  },
  profilePaperHeader: {
    marginTop: '16px',
    marginBottom: '16px'
  },
  flex: {
    display: 'flex'
  },
  flexWrap: {
    flexWrap: 'wrap'
  },
  profilePaperTitle: {
    marginBottom: '16px'
  },
  logoutButton: {
    marginTop: '16px'
  },
  changeSubButton: {
    height: '36px'
  },
  tableButtonRows: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '16px',
    alignItems: 'center'
  }
})
class ProfileScreen extends Component {
  renderUserName() {
    const { profile } = this.props
    if (!!profile) {
      return `${profile.first_name} ${profile.last_name}`
    } else {
      return 'N/A'
    }
  }

  renderSubscription() {
    const { subscription } = this.props
    if (!!subscription) {
      return `${subscription}`
    } else {
      return 'Trial'
    }
  }

  renderProfileCard() {
    const { profile, classes } = this.props

    const phoneNumber = !!profile.phoneNumber ?  parsePhoneNumber(profile.phoneNumber).formatNational() : ""
    return (
      <React.Fragment>
        <Paper className={classNames(classes.profilePaper)}>
          <div>
            <Typography variant='title' align='left' noWrap>
              {this.renderUserName.call(this)}
            </Typography>
            <Divider className={classNames(classes.profileDivider)} />
            <dl className={classNames('row')}>
              <dt className={classNames('col-3')}>Email</dt>
              <dd className={classNames('col-9')}>{profile.email}</dd>
              <dt className={classNames('col-3')}>Phone Number</dt>
              <dd className={classNames('col-9')}>{phoneNumber}</dd>
            </dl>
          </div>
        </Paper>
      </React.Fragment>
    )
  }

  handleDailyUpdateChange() {
    const { dispatch, projectId, dailyUpdateUsers, currentUserId  } = this.props
    const hasDailyUpdates = !!dailyUpdateUsers[currentUserId]

    dispatch(userActions.toggleDailyUpdate(projectId, hasDailyUpdates, currentUserId))
  }

  handleDailyCommitChange() {
    const { dispatch, projectId, dailyUpdateUsers, currentUserId, dailyCommitUsers  } = this.props
    const hasDailyUpdates = !!dailyCommitUsers[currentUserId]

    dispatch(userActions.toggleDailyCommit(hasDailyUpdates))
  }


  renderProjectCard() {
    const { classes, projectUsers, projectName, projectAddress, tasks, dailyUpdateUsers, currentUserId, dailyCommitUsers } = this.props

    const userCount = Object.keys(projectUsers).length

    const hasDailyCommits = !!dailyCommitUsers[currentUserId]

    return(
      <React.Fragment>

        <Paper className={classNames(classes.profilePaper)}>
          <div>
            <Typography variant='title' align='left' noWrap>
              {projectName}
            </Typography>
            <Divider className={classNames(classes.profileDivider)} />
            <dl className={classNames('row')}>
              <dt className={classNames('col-3')}>Address</dt>
              <dd className={classNames('col-9')}>{projectAddress}</dd>
              <dt className={classNames('col-3')}>User Count</dt>
              <dd className={classNames('col-9')}>{userCount}</dd>

              <dt style={{display: 'flex', alignItems: 'center'}} className={classNames('col-3')}><p>Daily Commitments</p></dt>

              <dd className={classNames('col-9')}>
                <FormControlLabel control={<Switch checked={hasDailyCommits} onChange={this.handleDailyCommitChange.bind(this)} color="primary" />} label="Sends a daily report of your upcoming commitments" />
              </dd>

              
            </dl>
          </div>

          <Divider className={classNames(classes.profileDivider)} />
          <Button
              onClick={this.onChangeProjectClicked.bind(this)}
              variant='contained'
              className={classNames(classes.changeSubButton)}
              color='primary'>
              Edit Project
          </Button>
        </Paper>

      </React.Fragment>
    )
  }

  onChangeProjectClicked() {
    const { dispatch, projectId } = this.props;
    dispatch(homeActions.editProject(projectId));
  }

  onChangeSubscriptionClicked() {
    const { dispatch } = this.props
    //window.location.assign('https://deonrobinson.typeform.com/to/v5Dfnc')
    dispatch(homeActions.changeSubscriptionDialog())
  }

  renderSubscriptionText() {
    const { subscription } = this.props

    if (!subscription || subscription.status !== 'active') {
      return (
        <React.Fragment>
          <Typography variant='body2'>
            You don't have a paid subscription.
          </Typography>
          <Typography variant='body1'>
            To collaborate on your projects, please upgrade your account.
          </Typography>
        </React.Fragment>
      )
    }

    if (subscription.status === 'active') {
      return (
        <React.Fragment>
          <Typography variant='body2'>{subscription.plan}</Typography>
          <br />
        </React.Fragment>
      )
    }
  }

  render() {
    const { profile, classes, projectName } = this.props

    if (!profile.isLoaded) {
      return (
        <div
          style={{
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex'
          }}>
          <CircularProgress />
        </div>
      )
    }

    if (profile.isEmpty) {
      return <p>Empty..</p>
    }
    return (
      <div className={classNames(classes.profileContainer)}>
        {this.renderProfileCard()}
        <React.Fragment>
          <Paper className={classNames(classes.profilePaper)}>
            {this.renderSubscriptionText()}

            <Divider style={{ marginTop: '16px', marginBottom: '16px' }} />
            <Button
              onClick={this.onChangeSubscriptionClicked.bind(this)}
              variant='contained'
              className={classNames(classes.changeSubButton)}
              color='primary'>
              Change Subscription
            </Button>
          </Paper>
          {this.renderProjectCard()}
          <Button
            variant='contained'
            color='primary'
            className={classNames(classes.logoutButton)}
            onClick={() => {
              userActions.logout()
            }}>
            SIGN OUT
          </Button>
        </React.Fragment>
      </div>
    )
  }
}

export default compose(
  withFirebase,
  connect((state, props) => {

    return {
      profile: getProfile(state),
      subscription: getProjectSubscription(state),
      projectName: getProjectName(state),
      dailyUpdateUsers: getDailyUpdateUsers(state),
      dailyCommitUsers: getDailyCommitUsers(state),
      currentUserId: getCurrentUserId(state),
      projectId: getProjectId(state),
      projectAddress: getProjectAddress(state),
      projectUsers: getProjectUsers(state)
    }
  }),
    connect(state => {
    return {
        projectId: getProjectId(state)
      };
  }),
  firebaseConnect((props: any) => {
    if (!props.projectId) {
        return [];
    }

    return [
        {
            path: `/dailyReport/projects/${props.projectId}/settings/`,
            storeAs: 'REPORT_SETTINGS'
        }
    ];
}),
  withStyles(styles, { withTheme: true })
)(ProfileScreen)



// WEBPACK FOOTER //
// ./src/containers/ProfileScreen.tsx